import {publishClientSideMetrics} from "../handler/ParentDataHandler";
import {isOneBox} from "./Util";

export const PICK_TAB_METRIC_KEY = "SCC_OUTBOUND_PICK_TAB";
export const ROUTE_INFO_METRIC_KEY = "SCC_OUTBOUND_ROUTE_INFO_VIEW";
export const ROUTE_TAB_METRIC_KEY = "SCC_OUTBOUND_ROUTE_TAB";
export const ASSOCIATE_TAB_METRIC_KEY = "SCC_OUTBOUND_ASSOCIATE_TAB";
export const GLOBAL_METRIC_KEY = "SCC_OUTBOUND_PVSW";

export const RSWS_ROUTE_LIST_METRIC = "getRouteInformation";
export const RSWS_ROUTE_DETAIL_METRIC = "getContainersFromRSWS";
export const RSWS_DWP_UPLOAD_METRIC = "uploadDWP";
export const RSWS_DWP_METADATA_METRIC = "getDWPMetadata";
export const RSWS_GET_PACKAGE_METRIC = "getPackageMetricsFromRSWS";
export const RSWS_GET_PICK_STATUS_IN_GRID = "getPickStatusInGridFromRSWS";
export const RSWS_ASSOCIATE_METRIC = "getAssociateMetrics";
export const RSWS_STATION_CONFIG_METRIC = "getStationConfig";
export const RSWS_STATION_DETAILS_METRIC = "getStationDetails";
export const RSWS_SIDELINE_ROUTE_METRIC = "sidelineRoute";
export const RSWS_UNASSIGN_ROUTE_METRIC = "unassignRoute";
export const RSWS_PRIORITIZE_ROUTE_METRIC = "prioritizeRoute";
export const RSWS_CUT_ROUTE_METRIC = "cutRoute";
export const RSWS_FORCE_ASSIGN_ROUTE_METRIC = "forceAssign";
export const RSWS_GET_AR_WORKSTATION_METRIC = "getARWorkstationMetricsFromRSWS";
export const IVS_GET_PACKAGE_METRIC = "getPackageMetricsFromIVS";
export const SVS_GET_PACKAGE_METRIC = "getPackageMetricsFromSVS";
export const SVS_DRS_ROUTES_METRIC = "getDRSRoutes";
export const SVS_PACKAGE_HIERARCHY_METRIC = "getPackageHierarchyFromSVS";
export const SVS_FLOOR_DATA_METRIC = "getFloorDataFromSVS";
export const ROUTE_CACHE_HIT_METRIC = "routeCacheHit";
export const ROUTE_CACHE_MISS_METRIC = "routeCacheMiss";
export const PICK_STATUS_IN_GRID_CACHE_HIT_METRIC = "pickStatusInGridCacheHit";
export const PICK_STATUS_IN_GRID_CACHE_MISS_METRIC = "pickStatusInGridCacheMiss";
export const RSWS_GET_CONFIG = "getRSWSConfig";
export const RSWS_GET_STATION_CONFIG_SUCCESS = "getStationConfigSuccess";

export const ERROR_COUNT_METRIC = "javascript";  //"Error" is appended in publish method
export const ONE_BOX_IDENTIFIER = "ONEBOX";

export const MetricType = {
    SUCCESS: true,
    FAILED: false
}

/**
 * Publishes API operation metrics: Latency, Errors, Counts and Station-Wise Counts.
 * @param startTime
 * @param stationCode
 * @param processName
 * @param metricName
 * @param type
 * @param error - exception if any
 */
export function logOperationalMetric(startTime, stationCode, processName, metricName, type, error) {
    logLatencyMetric(startTime, processName, metricName)
    if (type === MetricType.SUCCESS) {
        logCounterMetric(stationCode, processName, metricName)
    } else {
        logErrorMetric(stationCode, processName, metricName, error)
    }
}

/**
 * Publishes error metric.
 * @param stationCode
 * @param processName
 * @param metricName
 * @param error - exception if any
 */
export function logErrorMetric(stationCode, processName, metricName, error) {
    let errorMetric = metricName + "Error";
    if (error && error.response) {
        //axios client was given an error response (5xx, 4xx)
        errorMetric += getErrorStatusStr(error.response.status);
    } else if (error && error.request) {
        //axios client never received a response, and the request was never left
        errorMetric = metricName + "NetworkError";
    }
    logCounterMetric(stationCode, processName, errorMetric)
}

function getErrorStatusStr(status) {
    if (!status || status < 400) {
        return "";
    } else if (status >= 400 && status < 500) {
        return "4xx";
    } else if (status >= 500) {
        return "5xx";
    }
}

/**
 * Publishes counter metrics and station wise counter metrics.
 * @param stationCode
 * @param processName
 * @param metricName
 */
export function logCounterMetric(stationCode, processName, metricName) {
    const combinedProcessName = `${stationCode}_${processName}`;
    const countMetricReq = publishClientSideMetricsRequest(processName, metricName, 1, metricTypeEnum.COUNT);
    const stationWiseCountMetric = publishClientSideMetricsRequest(combinedProcessName, metricName, 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
    publishClientSideMetrics(stationWiseCountMetric);
    if(isOneBox()){
        const oneBoxKey = getOneBoxProcessName(processName);
        const oneBoxCountMetricReq = publishClientSideMetricsRequest(oneBoxKey, metricName, 1, metricTypeEnum.COUNT);
        publishClientSideMetrics(oneBoxCountMetricReq);
    }
}

/**
 * Publishes latency metrics
 * @param startTime
 * @param processName
 * @param metricName
 */
export function logLatencyMetric(startTime, processName, metricName) {
    const metricValue = getTimeDiff(startTime);
    const timeMetricReq = publishClientSideMetricsRequest(processName, metricName, metricValue, metricTypeEnum.TIME);
    publishClientSideMetrics(timeMetricReq);
    if (isOneBox()) {
        const oneBoxKey = getOneBoxProcessName(processName);
        const oneBoxTimeMetricReq = publishClientSideMetricsRequest(oneBoxKey, metricName, metricValue, metricTypeEnum.TIME);
        publishClientSideMetrics(oneBoxTimeMetricReq);
    }
}

const getOneBoxProcessName = processName => {
    return `${processName}_${ONE_BOX_IDENTIFIER}`
}

function getTimeDiff(time) {
    return Date.now() - time;
}

const metricTypeEnum = {
    COUNT: "count",
    TIME: "time"
};

function publishClientSideMetricsRequest(processName, metricName, metricValue, metricType) {
    return {
        processName: processName,
        metricName: metricName,
        metricValue: metricValue,
        metricType: metricType
    }
}


// WEBPACK FOOTER //
// ./src/components/util/MetricUtil.js